import React from 'react'
import styled from 'styled-components'

import ArrowUp from '../../images/svg/arrow-up.svg'
import Facebook from '../../images/svg/facebook.svg'
import Instagram from '../../images/svg/ig.svg'
import Logo from '../../images/svg/motat_header.svg'
import TripAdvisor from '../../images/svg/tripadvisor.svg'
import Twitter from '../../images/svg/twitter.svg'
import YouTube from '../../images/svg/yt.svg'
import { H4 } from '../Typography/Typography'
import Link from '../atoms/link'
import theme from '../atoms/theme'
import Button from '../molecules/button'

const { breakpoints, colours, font, animation } = theme

const FooterStyled = styled.div`
  background-color: ${colours.dark};
  color: ${colours.light};
`

const MotatLogo = styled(Logo)`
  width: 26.2rem;

  @media only screen and ${breakpoints.fromNormalScreen} {
    width: 25.4rem;
    height: 4.3rem;
  }
`

const ThirdsContainer = styled.div`
  display: flex;
  padding-bottom: 0;

  @media only screen and ${breakpoints.toNormalScreen} {
    flex-direction: column;
  }

  @media only screen and ${breakpoints.fromNormalScreen} {
    padding-bottom: 3.6rem;
  }
`

const Third = styled.div`
  flex-basis: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  @media only screen and ${breakpoints.toNormalScreen} {
    border-bottom: 0.1rem solid ${colours.darkTint1};
    padding: 2.8rem 0 2.8rem 0;

    &:first-child {
      padding-top: 0;
    }
  }

  @media only screen and ${breakpoints.fromNormalScreen} {
    border-right: 0.1rem solid ${colours.darkTint1};
    padding: 0 3rem;
  }

  a {
    text-decoration: none;
  }

  &:last-child {
    border-right: none;
  }
`

const LogoTitle = styled.div`
  font-size: ${font.fontSizeDesktop};
`

const FooterIcons = styled.div`
  a {
    display: inline-block;
    margin: 0 1rem;
    transition: color ${animation.defaultLength} ease-in-out;

    &:hover {
      color: ${colours.primary};
    }
  }

  a > * {
    width: 3.2rem;
    height: 3.2rem;
  }
`

export const StyledH4 = styled(H4)`
  @media only screen and ${breakpoints.toNormalScreen} {
    font-size: 1.8rem;
    margin-bottom: 0;

    ${Third} & {
      margin-bottom: 2rem;
    }
  }

  a {
    text-decoration: none;
    transition: color ${animation.defaultLength} ease-in-out;

    &:hover {
      color: ${colours.primary};
    }
  }
`

const BackToTopButton = styled(Button)`
  display: flex;
  align-items: center;
`

type InteractiveFooterType = {
  isSimple: boolean
}

const InteractiveFooter = (props: InteractiveFooterType): JSX.Element => {
  const { isSimple } = props

  return (
    <FooterStyled data-scroll-section>
      <ThirdsContainer>
        <Third>
          {isSimple && (
            <div>
              <MotatLogo />
              <LogoTitle>Museum of Transport and Technology</LogoTitle>
            </div>
          )}
          {!isSimple && (
            <Link to='/'>
              <MotatLogo />
              <LogoTitle>Museum of Transport and Technology</LogoTitle>
            </Link>
          )}
        </Third>
        <Third>
          <BackToTopButton
            onClick={(): void => {
              window.locomotiveScroll?.scrollTo('top')
            }}
          >
            <>
              <ArrowUp /> Back to Top
            </>
          </BackToTopButton>
        </Third>
        {!isSimple && (
          <Third>
            <FooterIcons>
              <Link to='https://www.facebook.com/MOTATNZ'>
                <Facebook />
              </Link>
              <Link to='https://www.youtube.com/user/MOTATNZ'>
                <YouTube />
              </Link>
              <Link to='https://www.instagram.com/motatnz'>
                <Instagram />
              </Link>
              <Link to='https://twitter.com/MOTAT_NZ'>
                <Twitter />
              </Link>
              <Link to='https://www.tripadvisor.co.nz/Attraction_Review-g1811027-d256915-Reviews-Museum_of_Transport_and_Technology-Auckland_North_Island.html'>
                <TripAdvisor />
              </Link>
            </FooterIcons>
          </Third>
        )}
      </ThirdsContainer>
    </FooterStyled>
  )
}

export default InteractiveFooter
